import React from "react";

const steps = [
  { num: "01", title: "Create a session",      desc: "Set up your training or event and generate a unique QR code in seconds." },
  { num: "02", title: "Participants check in",  desc: "Attendees scan to check in. Data is recorded instantly, with no friction." },
  { num: "03", title: "Export your records",    desc: "Download clean, audit-ready attendance reports the moment a session ends." },
];

export default function Hero({ setActive }) {
  return (
    <section style={s.section}>
      <style>{`
        .hero-steps {
          display:grid; grid-template-columns:repeat(3,1fr);
          margin:0 auto 40px; text-align:center;
          border:2px solid #13202d; border-radius:12px;
          overflow:hidden; width:70%;
        }
        .hero-step { padding:24px 22px; border-right:1px solid #1e2e45; background:#13202d; }
        .hero-step:last-child { border-right:none; }

        .hero-btnrow { display:flex; justify-content:center; gap:12px; margin-bottom:60px; }

        .hero-values { display:flex; justify-content:center; gap:32px; flex-wrap:wrap; }

        @media(max-width:640px){
          .hero-steps {
            grid-template-columns:1fr;
            width:100%;
          }
          .hero-step { border-right:none; border-bottom:1px solid #1e2e45; }
          .hero-step:last-child { border-bottom:none; }

          .hero-btnrow { flex-direction:column; align-items:center; gap:10px; margin-bottom:40px; }
          .hero-btnrow button { width:100%; max-width:300px; }

          .hero-values { gap:14px; }
        }
      `}</style>

      <div style={s.badge}><span style={{ color:"#3d372e", fontSize:10, marginRight:10 }}>⬤</span>COMING SOON</div>

      <h1 style={s.h1}>
        Verified presence,<br />
        <span style={s.bold}>every time.</span>
      </h1>

      <p style={s.sub}>
        Simple, real-time attendance and access tracking for training and
        events. Replace paper registers with clear, audit-ready records.
      </p>

      <div className="hero-btnrow">
        <button style={s.btnPrimary}   onClick={() => setActive("Contact")}>Book a Demo</button>
        <button style={s.btnSecondary} onClick={() => setActive("Our Story")}>Our Story</button>
      </div>

      <div className="hero-steps">
        {steps.map((step) => (
          <div key={step.num} className="hero-step">
            <span style={s.stepNum}>{step.num}</span>
            <div style={s.stepTitle}>{step.title}</div>
            <div style={s.stepDesc}>{step.desc}</div>
          </div>
        ))}
      </div>

      <div className="hero-values">
        {["TRUST", "MINIMALISM", "SCALABILITY", "PRECISION"].map((v) => (
          <span key={v} style={s.value}><span style={s.dash}>— </span>{v}</span>
        ))}
      </div>
    </section>
  );
}

const s = {
  section:      { background:"#080D20", padding:"80px 24px 60px", textAlign:"center", fontFamily:"'Segoe UI', sans-serif" },
  badge:        { fontSize:12, fontWeight:600, color:"#6b7280", letterSpacing:"0.08em", marginBottom:28, display:"block" },
  h1:           { fontSize:"clamp(28px,5vw,52px)", fontWeight:400, color:"#fff", lineHeight:1.2, margin:"0 0 20px" },
  bold:         { fontWeight:700 },
  sub:          { fontSize:15, color:"#6b7280", lineHeight:1.7, margin:"0 auto 32px", maxWidth:540 },
  btnPrimary:   { background:"#998046", color:"#fff", border:"none", borderRadius:8, padding:"11px 28px", fontSize:14, fontWeight:600, cursor:"pointer" },
  btnSecondary: { background:"#080D20", color:"#fff", border:"2px solid #13202d", borderRadius:8, padding:"11px 28px", fontSize:14, fontWeight:500, cursor:"pointer" },
  stepNum:      { fontSize:12, fontWeight:700, color:"#998046", display:"block", marginBottom:10 },
  stepTitle:    { fontSize:14, fontWeight:700, color:"#fff", marginBottom:8 },
  stepDesc:     { fontSize:13, color:"#8a93a6", lineHeight:1.6 },
  value:        { fontSize:12, fontWeight:600, letterSpacing:"0.05em", color:"#fff" },
  dash:         { color:"#998046" },
};
